import { getClientIdsForAuthType, isMcpClientId } from "./client-config";
import type { McpAuthType, McpClientId } from "./types";

export function resolveMcpClientForAuthType(
  clientParam: string | undefined,
  authType: McpAuthType
): McpClientId {
  const allowed = getClientIdsForAuthType(authType);
  if (isMcpClientId(clientParam) && allowed.includes(clientParam)) {
    return clientParam;
  }
  const fallback = allowed[0];
  if (!fallback) {
    throw new Error(`No MCP clients configured for auth type: ${authType}`);
  }
  return fallback;
}
